import React from "react";
import "materialize-css/dist/js/materialize.min.js";
import ComponentHeader from "../components/ComponentHeader";
import M from "materialize-css/dist/js/materialize.min";

const PERSONAL_PROJECTS = [
  {
    title: "LSEasyDocs",
    description:
      "EasyDocs is an industry standard document management system used to create,  modify, manage document and its life cycle using workflows with integrated office online tool to edit the document. Also, the support for eTMF features for drug research companies to best manage their documents related to their studies",
    websiteLink: "https://www.arisglobal.com/lifesphere-easydocs/",
    technologyUsed: [
      <p>
        Developed using <b>MVC Architecture</b>.
      </p>,
      <p>
        Built with <b>Spring Boot</b> and <b>JSP</b>.
      </p>,
      <p>
        Stored user and product information in <b>MySQL</b> database.
      </p>,
    ],
  },
  {
    title: "Retail Merchandising System",
    description:
      "RMS is retail sale management application used to execute core merchandising activities including product management, inventory system, purchasing and vendor management and financial tracking",
    websiteLink: "#",
    technologyUsed: [
      <p>
        Developed using <b>JAVA</b>.
      </p>,
      <p>
        Built with <b>Spring Boot </b> and <b>Kafka</b>.
      </p>,
      <p>
        Stored user and product information in <b>Oracle</b> database.
      </p>,
    ],
  },
  // {
  //   title: "Mobiquity Wallet",
  //   description:
  //     "Mobiquity Wallet offers a feature-rich digital wallet for consumers and a robust and       flexible platform for service providers and their partners. It combines innovations in       payments with attention to human factor and innovative digital technology. Designed to support a large and complex ecosystem, mobiquity Wallet enables financial institutions,       retailers, telecom operators and other consumer service providers to re-engage and connect       directly with their consumers",
  //   websiteLink: "https://www.arisglobal.com/lifesphere-easydocs/",
  //   technologyUsed: [
  //     <p>
  //       Developed using <b>MuleSoft</b>.
  //     </p>,
  //     <p>
  //       Built with <b>JAVA</b> and <b>Android</b>.
  //     </p>,
  //     <p>
  //       Stored user and product information in <b>Oracle</b> database.
  //     </p>,
  //   ],
  // },
  {
    title: "RemoteLED Controlling System",
    description:
      "Controlling all the light nodes installed in an organization remotely from a single       location. And also provide schedules / profiles using which the lights can be controlled in an       efficient way. Also, with the data that is collated from the lights, provide analytics and whatif analysis to the organization to better manage and effectively control their energy consumption",
    technologyUsed: [
      <p>
        Developed using <b>Spring MVC</b>.
      </p>,
      <p>
        Design and develop the interactive UI using JSP with CSS Bootstrap.
      </p>,
      <p>
        Stored user and product information in <b>MySQL</b> database.
      </p>,
    ],
  },
];

class Projects extends React.Component {
  componentDidMount() {
    const tooltipElem = document.querySelectorAll(".project-tooltip");
    M.Tooltip.init(tooltipElem, {
      enterDelay: 400,
      exitDelay: 200,
    });

    const modalElem = document.querySelectorAll(".modal");
    M.Modal.init(modalElem, {
      onCloseEnd: () => this.setState({ selectVideo: null }),
    });
  }

  render() {
    const renderTechnologyUsed = (sentences) => {
      if (!sentences) {
        return null;
      }

      return sentences.map((sentence, index) => {
        return (
          <li
            key={index}
            style={{ listStyleType: "disc", display: "list-item" }}
          >
            {sentence}
          </li>
        );
      });
    };

    const renderPersonalCards = () => {
      return PERSONAL_PROJECTS.map((data) => {
        return (
          <div
            key={data.title}
            className="col-md-6 col-lg-6 col-xl-4"
            style={{ paddingBottom: 30 }}
          >
            <div className="card darken-1 sticky-action personal-card">
              <div
                className="card-content"
                style={{ borderTop: "1px solid rgba(160, 160, 160, 0.2)" }}
              >
                <div className="card-title activator purple-text">
                  <div
                    className="row align-items-center"
                    style={{ marginBottom: 0 }}
                  >
                    <div className="col-10 justify-content-start activator">
                      {data.title}
                    </div>
                    <div
                      className="project-tooltip"
                      data-tooltip="View Technology Used"
                      data-position="left"
                    >
                      <i className="material-icons right">more_vert</i>
                    </div>
                  </div>
                </div>

                <div className="card-data">
                  <p>{data.description}</p>
                </div>
              </div>

              <div className="card-reveal">
                <span className="card-title brown-text font-weight-light">
                  Technology Used
                  <i className="material-icons right brown-text">close</i>
                </span>
                <div style={{ paddingLeft: 12 }}>
                  <ul>{renderTechnologyUsed(data.technologyUsed)}</ul>
                </div>
              </div>
            </div>
          </div>
        );
      });
    };

    return (
      <div>
        <ComponentHeader heading={"Projects"} />
        <div className="container flow-text project-container">
          <div className="row justify-content-start">
            {renderPersonalCards()}
          </div>
        </div>
      </div>
    );
  }
}

export default Projects;
